export default __webpack_public_path__ + "static/media/img3.9cf6963c.jpeg";